// Papa Diaries — shared editorial motion primitives (Phase 3A Step 5)
//
// Opt-in only. Does nothing on any page with no [data-pd-reveal]
// elements. Reveals opacity/small-translate once per element via a
// single shared IntersectionObserver, then unobserves — no ongoing
// work after that. Respects prefers-reduced-motion by never hiding
// content for those users in the first place.
//
// Opt-in API:
//   data-pd-reveal            default reveal (opacity + small rise)
//   data-pd-reveal="rise"     same as default, explicit
//   data-pd-reveal="fade"     opacity only, no vertical travel
//   data-pd-reveal="image"    opacity + very slight scale-settle
//   data-pd-delay="200"       extra delay in ms for this element
//   data-pd-stagger="80"      on a group container: staggers its
//                             [data-pd-reveal] descendants by 80ms
//                             each, in DOM order (value optional,
//                             defaults to 80ms if omitted/invalid)
(function () {
  'use strict';

  var SELECTOR = '[data-pd-reveal]';
  var elements = document.querySelectorAll(SELECTOR);

  // Nothing opted in on this page — exit immediately, no observer,
  // no class changes, no work at all.
  if (!elements.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reduced motion: never enter the hidden pre-reveal state at all.
  // Content stays exactly as it already renders in the page's own
  // CSS — immediate, no travel, no stagger delay.
  if (reduceMotion) return;

  var DEFAULT_STAGGER_STEP = 80; // ms

  // Compute each opted-in element's stagger offset, if it sits
  // inside a [data-pd-stagger] group container.
  var staggerDelays = new WeakMap();
  document.querySelectorAll('[data-pd-stagger]').forEach(function (group) {
    var step = parseInt(group.getAttribute('data-pd-stagger'), 10);
    if (!(step > 0)) step = DEFAULT_STAGGER_STEP;
    group.querySelectorAll(SELECTOR).forEach(function (child, index) {
      staggerDelays.set(child, index * step);
    });
  });

  elements.forEach(function (el) {
    var ownDelay = parseInt(el.getAttribute('data-pd-delay'), 10);
    if (!(ownDelay > 0)) ownDelay = 0;
    var staggerDelay = staggerDelays.get(el) || 0;
    var totalDelay = ownDelay + staggerDelay;
    if (totalDelay > 0) {
      el.style.setProperty('--pd-delay', totalDelay + 'ms');
    }
  });

  // Only now do opted-in elements become eligible for the hidden
  // pre-reveal CSS state (see pd-motion.css) — this line is the
  // progressive-enhancement gate. If this script never runs, this
  // class is never added, and nothing is ever hidden.
  document.documentElement.classList.add('pd-motion-ready');

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        obs.unobserve(entry.target);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  elements.forEach(function (el) {
    observer.observe(el);
  });
})();
